var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFsaB2Lineas2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 156.1 74.7",
    style: {
      enableBackground: "new 0 0 156.1 74.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1D1D1B;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M73.5,2c3.5-0.5,1.9,8.2,1.4,12c-0.9,6.9,0,16.1-0.1,24.4c-0.1,6.7-1.2,12.8-0.9,18.9c0.1,2.2-0.3,5.1-0.6,5.4   c-1.8,2-1.9-2.4-1.9-3.9c0.2-16-2-34.2-0.7-49C70.9,7.7,71.1,2.4,73.5,2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M113.2,18.5c-4.1,2.6-2.2-5.6-0.2-5.7c0.7,0,3.1,1.4,3.3,2.5c0.2,1-2,4.5-2,4.5   C113.4,20,112.5,19.1,113.2,18.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M29.1,16.2c2.8,0.2,5.3,0.2,5.1,3.7c-0.1,1-1.7,2.9-3.1,2.8C29.1,22.5,28.2,18.1,29.1,16.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M110.8,22.4c1.4-0.4,2.6,2.4,2,4.2c-0.6,1.8-2.2,3.7-3.1,6c-2,5.5-2.5,11.3-4.5,16.3c-0.1,0.2-2.7,3.4-2,0   c1.1-5.6,2-12.2,3.4-18.3C107.1,28.1,108.7,23,110.8,22.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M150.6,32.3c-0.6-2.8,1.1-3.8,1.9-5c0.7-1,0.7-3.3,2.8-2.9c4.4,0.8-0.4,8.8-2.8,8.5   C151.6,32.8,151.7,31.5,150.6,32.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M35.9,27c3.5-0.6,4.2,7.8,3.9,9.6c-0.2,1.2,1.3,3.8,1.2,5.3c-0.2,3.7,4.6,9.1,3.6,11.2c-0.4,0.8-1.6,0.4-2,0   c-1.1-0.9-3.8-9.1-4.3-11c-1.2-4.1-2.8-6.7-3.9-9.6c-0.3-0.9-1-4.7-0.8-5C33.7,27.4,36.5,26.9,35.9,27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M149,35.9c3.1-0.6,1.2,5.9,0,7.3c-3.7,4.2-7.9,10.4-10.8,15.6c-1.8,3.3-3.3,5.2-5,8.7c-0.5,1-4.3,4.4-3.9,0.5   c0.1-1.2,4.8-8.6,6-10.5c3.7-5.8,7.8-13.2,11.3-19.1C147.2,37.5,148.2,36,149,35.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0.6,41.7c3.8-1.3,5.3,5.3,6.7,8.1c2.9,5.9,7.6,13.5,10.7,19.5c0.6,1.3,1.4,2.8,1.7,3.7   c0.8,2.1,1.2,5.5-1.2,2.5c-1.5-1.9-3.2-4.7-4.6-7.3C10.1,61.6,5.4,54.5,2,48.4c-0.7-1.3-0.7-3-1.6-3.9C-0.4,43.8-1,42.3,0.6,41.7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFsaB2Lineas2);
export default __webpack_public_path__ + "static/media/FSA-B2-lineas2.94b99bc25878af7fd845f7b3c3c1cf46.svg";
export { ForwardRef as ReactComponent };